export var BadgeTypes = {
    grey: 'grey',
    outlined: 'outlined',
    warning: 'warning',
    info: 'info',
    success: 'success',
    danger: 'danger',
};
